import { Outlet } from 'react-router-dom'

import styles from './Layout.module.scss'
import { Avatar } from '@percent/lemonade'
import { LayoutProps } from './Layout.types'

export const Layout = ({ children, logo, programName }: LayoutProps) => (
  <div className={styles.outerContainer}>
    <div className={styles.brandedBackground} />
    <Outlet />
    <div className={styles.container}>
      {logo && (
        <div className={styles.logoWrapper}>
          <Avatar
            image={logo}
            size="xlarge"
            alt={programName ?? 'Unnamed program logo'}
          />
        </div>
      )}
      {children}
    </div>
  </div>
)
